import { externalReferralSearchForGrid } from '../../../spd/components/ExternalReferral/ExternalReferralSearch';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import {
  CreateUpdateExternalReferralDto,
  CreateUpdateExternalReferralDtoFromJSON,
} from '../autogenerated/spdApiClient';
import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import {
  ExternalReferralSchema,
  ExternalReferralWithoutPeselSchema,
} from '../validation/schemas';
import { validateAgainst } from '../validation/validateAgainst';

export interface ExternalReferralContextInterface {
  create: (dto: CreateUpdateExternalReferralDto) => Promise<void>;
  getByUserCompanyByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    setRefresh?: () => void,
  ) => Promise<GridRecord[]>;
  getByUserCompanyCount: (filterText?: string) => Promise<number>;
  getWithoutJudgmentsByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    companyId?: string,
  ) => Promise<GridRecord[]>;
  getWithoutJudgmentsCount: (
    filterText?: string,
    companyId?: string,
  ) => Promise<number>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
    companyId?: string,
  ) => Promise<GridRecord[]>;
  getAllCount: (filterText?: string, companyId?: string) => Promise<number>;
}

export const ExternalReferralContext = (api: DefaultApi) => {
  return {
    create: (dto: CreateUpdateExternalReferralDto) =>
      api.externalReferralControllerCreate(dto),
    getByUserCompanyByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      setRefresh?: () => void,
    ) => {
      const data = await api.externalReferralControllerGetByCompaniesByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );
      return data.map(external =>
        externalReferralSearchForGrid(external, setRefresh, true),
      );
    },

    getByUserCompanyCount: (filterText?: string) =>
      api.externalReferralControllerGetByCompaniesCount(filterText || ''),

    getWithoutJudgmentsByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      companyId?: string,
    ) => {
      const data =
        await api.externalReferralControllerGetWithoutJudgmentsByPortion(
          pageSize,
          pageNumber,
          orderBy || '',
          orderDirection || '',
          filterText || '',
          companyId,
        );
      return data.map(external => externalReferralSearchForGrid(external));
    },

    getWithoutJudgmentsCount: (filterText?: string, companyId?: string) =>
      api.externalReferralControllerGetWithoutJudgmentsCount(
        filterText || '',
        companyId,
      ),

    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
      companyId?: string,
    ) => {
      const data = await api.externalReferralControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
        companyId,
      );
      return data.map(external => externalReferralSearchForGrid(external));
    },

    getAllCount: (filterText?: string, companyId?: string) =>
      api.externalReferralControllerGetAllCount(filterText || '', companyId),
  };
};

export const validate = (externalReferral: CreateUpdateExternalReferralDto) =>
  validateAgainst(ExternalReferralSchema, externalReferral);

export const validateWithoutPesel = (
  externalReferral: CreateUpdateExternalReferralDto,
) => validateAgainst(ExternalReferralWithoutPeselSchema, externalReferral);

export const newExternalReferral = (): CreateUpdateExternalReferralDto => {
  return CreateUpdateExternalReferralDtoFromJSON({
    exam: { external: true },
  });
};
